<template>
  <div class="Bgc-white">
    <Header/>
    <div class="contentContacto">
      <div class="container contacto">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-12 mb-3">
            <p class="supertitle">{{$t('language.posadasCorporate.reservacionCancelacion.cancelar')}}</p>
          </div>
          <div class="col-lg-10 col-12 position-relative cancelarReserva mb-5">
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">

                <p slot="header" class="mb-0 text-right subtitle">{{$t('language.posadasCorporate.reservacionCancelacion.numConfirmacion')}}: <span class="referencia subtitle">{{noReservacion}}</span></p>
                <div class="pb-2">
                  <p class="estancia"><i class="icon-building"></i>{{$t('language.posadasCorporate.reservacionCancelacion.datosEstancia')}}</p>
                </div>
                <!--Loader-->
                <Loader v-if="initPage"/>
                <!--Loader-->
                <div v-if="!initPage">
                  <div class="pb-2">
                    <img class="d-inline-block mr-3 imgCancelacion"
                         v-bind:src="hotelMainImage" alt="">
                    <p class="d-inline-block"><b class="subtitle">{{hotelName}}
                    </b></p>
                  </div>
                  <div class="pb-2">
                    <p class="mb-2"><b class="subtitle mb-0">{{$t('language.posadasCorporate.reservacionCancelacion.Habitaciones')}}</b></p>
                    <p><b>{{habitaciones}}</b></p>
                  </div>
                  <div class="row pb-2">
                    <div class="col-12 col-lg-4">
                      <div class="row">
                        <i class="icon-calendar col-1"></i>
                        <p class="col-10">{{checkIn}} - {{checkOut}}<br>
                          <span class="notas">
                            {{numberOfNights}}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="row">
                        <i class="icon-bed col-1"></i>
                        <p class="col-10">{{totalRooms}}<br>
                          <span class="notas">{{roomContractTypeName}}</span>
                        </p>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="row">
                        <i class="icon-user col-1"></i>
                        <p class="col-10">{{huespedes}}<br>
                          <span class="notas">{{totalAdults}}{{totalChildren}}{{totalInfants}}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row pb-3">
                    <div class="col-12 col-lg-4">
                      <div class="row">
                        <p class="col-12 infoParrafo"><b class="mb-0">{{$t('language.posadasCorporate.reservacionesCancelada.text8')}}</b>
                          <span>{{huesped}}</span>
                        </p>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="row">
                        <p class="col-12 infoParrafo"><b class="mb-0">{{$t('language.posadasCorporate.reservacionCancelacion.companion')}}</b>
                          <span>{{companion}}</span>
                        </p>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="row">
                        <p class="col-12 infoParrafo"><b class="mb-0">{{$t('language.posadasCorporate.reservacionCancelacion.paymentType')}}</b>
                          <span>{{payment}}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="col-12 row justify-content-lg-end justify-content-start">
                      <div class="row col-12 col-lg-6 float-right">
                        <div class="col-6 row">
                          <p class="subtitle mb-0">{{ $t('language.posadasCorporate.generals.totalEstanciaImpuestos') }} {{numberOfNights}}:</p>
                        </div>
                        <div class="col-6">
                          <br>
                          <p class="subtitle mb-0 text-right">$ {{((ls.get('Profile').data.profileId.toLowerCase()=="pyp"||ls.get('Profile').data.profileId.toLowerCase()=="pypsa"||!ls.get('Profile').data.ratesPermissionsResponse.showRates)&&(tabActiveFR==="Tarifa Negociada"||tabActiveFR==="Negotiated Rate")?guiones:globalFunctions.numberFormat(totalCostWithTaxes, 2, '.', ',') )   }}<span
                            class="moneda">{{currencyCode}}</span></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card>
            </b-card-group>
          </div>
          <div class="col-lg-10 col-12 mb-5">
            <p class="subtitle">{{$t('language.posadasCorporate.reservacionCancelacion.recomendation')}}:
            </p>
            <form @submit.prevent="">
              <div class="form-element" v-click-outside="outsideSearch">
                <label for=""><b>{{$t('language.posadasCorporate.reservacionCancelacion.titleSelect')}}*</b></label>
                <div class="contenidoSearch" @click="[buscador = true]">
                  <i class="search-icons icon-unfold-more" v-if="!buscador"></i>
                  <i class="search-icons icon-close pointer" v-if="buscador"
                     @click="search = ''"></i>
                  <input class="elipse pointer" readonly name="descripcion" type="text" :placeholder="$t('language.posadasCorporate.reservacionCancelacion.seleccionar')" autocomplete="off"
                         v-model="search">
                  <input class="elipse" name="cancelType" type="hidden"  v-model="code">
                </div>
                <div class="card buscadorCard vb buscadorCard__custom-width" v-if="buscador" v-bar>
                  <div>
                    <div class="buscador" v-for="perfil in filteredList" :key="perfil.id">
                      <p class="mb-1 nombre" @click="[cambiaValue(perfil), buscador = 0]" v-html="$options.filters.resalt( perfil.nombre , search)"></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-element">
                <label for=""><b>{{$t('language.posadasCorporate.reservacionCancelacion.titleTextArea')}}*</b></label>
                <textarea name="" id="" rows="1" cols="40" v-model="comentario"
                          maxlength="255" @paste="handlePaste"  onkeypress="return (event.charCode != 124)"></textarea>
                <label for="" class="notas">{{$t('language.posadasCorporate.generals.max255Caracteres')}}</label><br><br>
                <label for="" class="notas">* {{$t('language.posadasCorporate.reservacionCancelacion.camposRequeridos')}}</label>
              </div>
              <!--Loader-->
              <Loader v-if="enableLoader"/>
              <!--Loader-->
              <div class="row mt-4">
                <div class="col-12 col-lg-6 order-2 order-lg-1">
                  <router-link to="/" tag="button" class=" mt-3 secondary-button">
                    {{$t('language.posadasCorporate.reservacionCancelacion.regresar')}}
                  </router-link>
                </div>
                <div class="col-12 col-lg-6 order-1 order-lg-2 mb-3 mb-lg-0">
                  <button @click="getPoliticasTarifas" class=" mt-3 button " :disabled="isDisabled">
                    {{$t('language.posadasCorporate.reservacionCancelacion.cancelar')}}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <modal v-show="isModalErrorServicios" @close="closeModalErrorServicios" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>  {{$t('language.posadasCorporate.modales.reservacionCancelacion.headError')}}: </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{$t('language.posadasCorporate.modales.reservacionCancelacion.bodyError')}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 " @click="closeModalErrorServicios"
                aria-label="Close modal">
          {{$t('language.posadasCorporate.recuperarPassword.continuar')}}
        </button>
      </template>
    </modal>
    <Footer/>
  </div>
</template>
<script>
  import Header from '../../generales/Header.vue';
  import Footer from '../../generales/Footer.vue';
  import axios from 'axios';
  import SecureLS from 'secure-ls';
  import i18n from '../../../plugins/i18n';
  import Modal from '../../addons/Modal.vue';
  import Loader from '../../../components/loader/Loader.vue';
  import * as GlobalFunctions from "../../../utils/GlobalFunctions";



  export default {
    name: 'ReservacionesCancelacion',
    components: {
      Header,
      Modal,
      Loader,
      Footer,
    },
    data: () => {
      return {
        tipoClienteID: '',
        pyp: 'PYP', //no cambiar este valor
        pypsa: 'PYPSA', //no cambiar este valor
        tipoTarifa: 0,
        // buscador
        guiones: "------",
        tabActiveFR: "",
        rateOptionalSupplementResponseList: [],
        globalFunctions: GlobalFunctions,
        ls: new SecureLS({encodingType: 'aes'}),
        isModalErrorServicios : false,
        initPage: false,
        enableLoader: false,
        servicioName:'',
        noReservacion: '',
        token: '',
        guestEmail: '',
        buscador: false,
        language: '',
        search: '',
        code: '',
        comentario: '',
        perfiles: [],
        hotelName:'',
        checkIn:'',
        checkOut:'',
        numberOfNights:'',
        roomContractTypeName:'',
        totalRooms:'',
        huespedes:'',
        totalAdults:'',
        totalChildren:'',
        totalInfants:'',
        payment:'',
        companion:'',
        huesped:'',
        totalCostWithTaxes:'',
        currencyCode:'',
        habitaciones:'',
        hotelMainImage:'',
        dailyRate: '',
        hotelCode:'',
        contractCode:'',
        contractTypeCode:'',
        reservationData:[],
        cancelationNumber:'',
        ratePolicy: [],
        roomCode:'',
        datosHabHotModalCosto: {
          habitacion: null,
          hotel: null,
          localStor: null,
          userClientID: false,
          tabActive: null
        },
      }
    },
    created(){
      this.tipoClienteID = this.ls.get('ClientId').data;
      this.initPage = true;
      var ls = new SecureLS({encodingType: 'aes'});
      var a = '';
      a = this.ls.get('Token');
      this.token = a.data.substr(1);
      this.language  =this.ls.get("Language");
      this.perfiles = [];

      if(this.$store.getters.gettingConfirmationNumberForIsma.confirmationNumber != null ){
        this.noReservacion = this.$store.getters.gettingConfirmationNumberForIsma.confirmationNumber;
        this.ls.set('noReservacion', {data: this.$store.getters.gettingConfirmationNumberForIsma.confirmationNumber});
      }else{
        this.noReservacion = this.ls.get('noReservacion').data;
      }
      this.getData();

      axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_RC, {
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': 'Bearer '+ this.token,
          'Accept-language': this.language.data,
        }
      }).then(res => {

        var resObject=JSON.parse(JSON.stringify(res));
        if ( resObject.status === 200 || resObject.status === 201) {
          let description;
          let tipoCancelacion;
          for (let responseKey in resObject.data.response) {
            tipoCancelacion = resObject.data.response[responseKey].cancelType;
            description = resObject.data.response[responseKey].descripcion;
            this.perfiles.push({"cancelType": tipoCancelacion, "nombre":description});
          }
        } else {
          this.servicioName = process.env.VUE_APP_RC;
          this.isModalErrorServicios = true;

        }
      }).catch(error=>{
        let errorObject=JSON.parse(JSON.stringify(error));
        if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
          this.$router.push({ name: "Error" });
        }
// Error server 

        this.servicioName = process.env.VUE_APP_RC;
        this.isModalErrorServicios = true;
        if (errorObject.message === 'Request failed with status code 401') {
          this.clearLocalStorage()
        }
      });
    },
    methods: {
    handlePaste(event ) {
       const lang=this.ls.get('Language').data;
       console.log("value for this.language"+lang);
       const pastedText = (event.clipboardData || window.clipboardData).getData('text');
       if (pastedText.includes('|')) {           
        event.preventDefault();
         if(lang == 'es'){
           alert('El carácter "|" no está permitido al pegar texto.');           
        }else{
           alert('The "|" character is not allowed when pasting text');
        }
          
      }
     
  },
      settingSuppl(resObject) {
// Deeper
        this.ls.set('generalUp', true)
        var toS = 0
        var toIm = 0
        for(var i=0; i < resObject.data.response.rateOptionalSupplementResponseList.length; i++) {
          toS += resObject.data.response.rateOptionalSupplementResponseList[i].amount
          for(var j = 0; j < resObject.data.response.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList.length; j++) {
            if(resObject.data.response.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

              toIm += resObject.data.response.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList[j].taxAmount

            }}
        }
        this.ls.set('generalSuppl', toS)
        this.ls.set('generalSupplIm', toIm)

        var extraSupE = 0
        var extraSupIE = 0
        var extraToSE = 0

        var extraSupEFirstNight = 0
        var extraSupIEFirstNight = 0
        var extraToSEFirstNight = 0
        var ob = {
          extraSupE: extraSupE,
          extraSupIE: extraSupIE,
          extraToSE: extraToSE
        }
        var ob2 = {
          extraSupE: extraSupEFirstNight,
          extraSupIE: extraSupIEFirstNight,
          extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', ob2)

        this.ls.set('supleCondi', ob)


        if(resObject.data.response.numberOfNights != null && resObject.data.response.numberOfNights != "") {

          var numNuits = resObject.data.response.numberOfNights
        } else {
          var numNuits = 1
        }
        if(resObject.data.response.rateOptionalSupplementResponseList != null && resObject.data.response.rateOptionalSupplementResponseList.length != 0) {
          var suplObject = resObject.data.response.rateOptionalSupplementResponseList
          for(var i=0; i < suplObject.length; i++) {
            switch(suplObject[i].quantityType) {
              case 5:
                extraSupE += suplObject[i].amount / numNuits
                for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
                  if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                    extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

                  }
                }
                extraToSE += (extraSupIE + extraSupE)
                var obje = {
                  extraSupE: extraSupE,
                  extraSupIE: extraSupIE,
                  extraToSE: extraToSE
                }
                this.ls.set('supleCondi', obje)
                break;
              case 1:  case 7: // type 6 must be
                extraSupE += suplObject[i].amount / numNuits
                for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
                  if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                    extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

                  }
                }
                extraToSE += (extraSupIE + extraSupE)
                var obje = {
                  extraSupE: extraSupE,
                  extraSupIE: extraSupIE,
                  extraToSE: extraToSE
                }
                this.ls.set('supleCondi', obje)
                break;
              case 3:
                extraSupE += suplObject[i].amount / numNuits
                for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
                  if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                    extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits
                  }
                }
                extraToSE += (extraSupIE + extraSupE)
                var obje = {
                  extraSupE: extraSupE,
                  extraSupIE: extraSupIE,
                  extraToSE: extraToSE
                }
                this.ls.set('supleCondi', obje)
                break;
              case 8:
                extraSupE += suplObject[i].amount / numNuits
                for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
                  if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                    extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits
                  }
                }
                extraToSE += (extraSupIE + extraSupE)
                var obje = {
                  extraSupE: extraSupE,
                  extraSupIE: extraSupIE,
                  extraToSE: extraToSE
                }
                this.ls.set('supleCondi', obje)
                break;
              case 2: case 6:
                extraSupEFirstNight += suplObject[i].amount
                for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
                  if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                    extraSupIEFirstNight += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount

                  }
                }
                extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
                var obje = {
                  extraSupE: extraSupEFirstNight,
                  extraSupIE: extraSupIEFirstNight,
                  extraToSE: extraToSEFirstNight
                }
                this.ls.set('supleCondiOneFirstNight', obje)

                break;

              case 4:
                extraSupEFirstNight += suplObject[i].amount
                for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
                  if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                    extraSupIEFirstNight += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount

                  }
                }
                extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
                var obje = {
                  extraSupE: extraSupEFirstNight,
                  extraSupIE: extraSupIEFirstNight,
                  extraToSE: extraToSEFirstNight
                }
                this.ls.set('supleCondiOneFirstNight', obje)
                break;

              default:
                break;
            }

          }
        }

      },
      whichRoomCode(resObject) {
        this.ls.set("updateCostDetail", {data: null});
        let hotelDetail = this.ls.get("HotelDetailData").data;
        if(resObject.data.response.rateOptionalSupplementResponseList != null && resObject.data.response.rateOptionalSupplementResponseList.length != 0 && resObject.data.response.rateOptionalSupplementResponseList.length != "") {

          this.settingSuppl(resObject)
        }
        let habitacion =   {
          agreementCode: "",
          arrivalDate: hotelDetail.arrivalDate,
          beautiDateInput: hotelDetail.arrivalDate,
          beautiDateOutput: hotelDetail.departureDate,
          brandCode: hotelDetail.brandCode,
          currencyCode: hotelDetail.currencyCode,
          departureDate: hotelDetail.departureDate,
          discountCode: hotelDetail.discountCode,
          hotelCode: hotelDetail.hotelCode,
          hotelName: hotelDetail.hotelName,
          iataCode: hotelDetail.iataCode,
          motivaCode:hotelDetail.motivaNumber,
          profileType: "",
          promoCode: hotelDetail.promoCode,
          roomCodeList:  '',
          roomType: '',
          selectedRooms:  [],
          totalAdults: hotelDetail.totalAdults,
          totalChildren: hotelDetail.totalChildren,
          totalInfants: hotelDetail.totalInfants,
          totalRooms: hotelDetail.totalRooms,
        };
        let room = {
          benefitsRestrictions: {
            contractCode: hotelDetail.roomContractCode,
            rateDescription: "",
            rateName: "",
            benefits: "",
            restrictions: ""
          },
          desc: "",
          elipse: true,
          img: "",
          negotiatedRatesDetailPrice: {
            averageRatePerNight: hotelDetail.ratesResponse.averageCostPerNight,
            complementaryContractCode: hotelDetail.contractCode,
            contractCode: hotelDetail.roomContractCode,
            contractType: 1,
            currencyCode: hotelDetail.currencyCode,
            hasCombinedRates: false,
            nights: hotelDetail.numberOfNights,
            rateType: hotelDetail.roomContractTypeName,
            ratesDetailResponses:  hotelDetail.ratesResponse.ratesDetailResponseList,
            roomCode: hotelDetail.roomCode,
            subTotalRateTaxes: hotelDetail.ratesResponse.totalCostWithTaxes,
            totalRateWithTaxes: hotelDetail.ratesResponse.totalCost, //WithTaxes,
            totalRateWithoutTaxes: hotelDetail.ratesResponse.totalCostWithoutTaxes,
            totalSupplement: hotelDetail.totalSupplement,
            totalTaxes: hotelDetail.ratesResponse.totalTaxesWithSupplements,
            yieldType: 1
          },
          nights: hotelDetail.numberOfNights,
          price: hotelDetail.ratesResponse.totalCostWithTaxes,
          roomCode: hotelDetail.roomCode,
          title: hotelDetail.hotelName,
        };

        this.datosHabHotModalCosto.localStor = 'datosHabHotSelected';
        this.datosHabHotModalCosto.hotel = room;

        if(this.tabActive == 1) {
          this.datosHabHotModalCosto.whichRates = 'Negociadas';
        }
        if(this.tabActive == 2) {
          this.datosHabHotModalCosto.whichRates = 'Publicas';
        }
        if(this.$store.getters.gettingLang == 'es' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Public Rate') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Tarifa Pública'
        }
        if(this.$store.getters.gettingLang == 'en' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Tarifa Pública') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Public Rate'
        }

        if(this.$store.getters.gettingLang == 'es' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Negotiated Rate') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Tarifa Negociada'
        }
        if(this.$store.getters.gettingLang == 'en' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Tarifa Negociada') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Negotiated Rate'
        }
        this.datosHabHotModalCosto.habitacion = habitacion;
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.totalCostWithoutTaxesWihtSupplements = resObject.data.response.ratesResponse.totalCostWithoutTaxes//WihtSupplements

        this.ls.set('updateCostDetail', {data: this.datosHabHotModalCosto});
      },

      closeModalErrorServicios() {
        this.isModalErrorServicios = false;
      },
      setNoNull(data){
        if(data === null){
          data = "null";
        }
        return data;
      },
      getData(){
        var ls = new SecureLS({encodingType: 'aes'});
        var a = '';
        a = this.ls.get('Token');
        this.language = this.ls.get('Language');
        this.token = a.data.substr(1);
        var editOrDeleteSameProfileIdReservations = true;// this.ls.get('PROMOSH');
        var hasEditCancelPermissions = false;
        hasEditCancelPermissions = true;
        this.profile = this.ls.get('Profile');

        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_CODE, {
          confirmationNumber: this.noReservacion,
          profileType: this.profile.data.profileType,
          hasEditCancelPermissions: hasEditCancelPermissions,
          fullReservationData:true
        }, {
          withCredentials: true,
          credentials: 'include',
          headers: {'Authorization': 'Bearer '+ this.token,
            'Accept-Language': this.language.data,
            'Content-Type' : 'application/json'
          }
        })
          .then(res => {
            var resObject=JSON.parse(JSON.stringify(res));

            let response = resObject.data.response;
            this.ls.set('HotelDetailData', {data: response});
            this.tabActiveFR = response.roomContractTypeName
            if (this.tabActiveFR == "Tarifa Negociada" || this.tabActiveFR == "Negotiated Rate") {
              this.tipoTarifa = 1
            }
            if (this.tabActiveFR == "Tarifa Pública" || this.tabActiveFR == "Public Rate") {
              this.tipoTarifa = 2
            }
            this.whichRoomCode(resObject);
            if ( resObject.status === 200 || resObject.status === 201) {
              this.hotelName              = response.hotelDetailResponse.hotelName;
              this.checkIn                = response.arrivalDate;
              this.checkOut               = response.departureDate;
              this.numberOfNights         = this.getTextNights(response.numberOfNights);
              this.roomContractTypeName   = response.roomContractTypeName;
              this.totalRooms             = this.getTotalRooms(response.totalRooms);
              this.huespedes              = this.getHuesped(response);
              this.totalAdults            = this.getTotalAdults(response.totalAdults);
              this.totalChildren          = this.getTotalChildren(response.totalChildren);
              this.totalInfants           = this.getTotalInfants(response.totalInfants);
              this.payment                = this.getPaymentType(response.paymentResponse);
              this.huesped                = response.name + ' ' + response.fatherSurname + ' ' + response.motherSurname;
              this.companion              = this.ifNull(response.companionName) + ' ' + this.ifNull(response.companionFatherSurname) + ' ' + this.ifNull(response.companionMotherSurname);
              this.totalCostWithTaxes     = response.ratesResponse.totalCost //WithTaxes;
              this.currencyCode           = response.currencyCode;
              this.habitaciones           = this.getHabitaciones(response);
              this.hotelMainImage         = response.hotelDetailResponse.hotelMainImage;
              this.dailyRate              = response.ratesResponse.ratesDetailResponseList[0].roomCostWithTaxes;
              this.hotelCode              = response.hotelCode;
              this.contractCode           = response.roomContractCode;
              this.contractTypeCode       = response.roomContractTypeCode;
              this.guestID                = response.guestID;
              this.guestEmail             = response.email;

              // Get optional supplements string for confirmation screen
              var listRequeOpcionalesE = []
              var supleER = ""
              if(response.rateOptionalSupplementResponseList != null && response.rateOptionalSupplementResponseList != 0) {
                listRequeOpcionalesE = response.rateOptionalSupplementResponseList
                this.rateOptionalSupplementResponseList = response.rateOptionalSupplementResponseList
              }
              if(listRequeOpcionalesE.length != 0) {
                for(var i=0; i < listRequeOpcionalesE.length; i++) {
                  supleER +=  listRequeOpcionalesE[i].numSuppleCharged
                  supleER += " "
                  supleER += listRequeOpcionalesE[i].supplementName
                  supleER += ", "

                }
                supleER = supleER.slice(0, -2)
                this.ls.set('optionalSuCan', supleER)
              }

              // Get mandatory supplements for display on cancel confirmation
              // MANDATORY TEST OBJECTS
              var inter = [
                {
                  "supplementCode": "HL",
                  "supplementName": "HL",
                  "date": "24/03/2020",
                  "startDate": null,
                  "endDate": null,
                  "quantityType": 8,
                  "quantityValue": 1,
                  "quantityTypeText": "",
                  "unitPriceType": "F",
                  "unitPriceValue": 99.8,
                  "numSuppleCharged": 1,
                  "commOffsetType": "N",
                  "commOffsetValue": 0.0,
                  "commAmount": 0.0,
                  "mandatory": false,
                  "rateIncluded": false,
                  "supplementDescription": "HL",
                  "amount": 99.8,
                  "rateSupplementTaxesResponseList": [
                    {
                      "taxCode": "IVA",
                      "taxValue": 0.0,
                      "taxAmount": 15.968
                    }
                  ]
                },
                {
                  "supplementCode": "SPA",
                  "supplementName": "Masaje por estancia",
                  "date": "25/03/2020",
                  "startDate": null,
                  "endDate": null,
                  "quantityType": 2,
                  "quantityValue": 1,
                  "quantityTypeText": "",
                  "unitPriceType": "F",
                  "unitPriceValue": 1200.55,
                  "numSuppleCharged": 1,
                  "commOffsetType": "N",
                  "commOffsetValue": 0.0,
                  "commAmount": 0.0,
                  "mandatory": false,
                  "rateIncluded": false,
                  "supplementDescription": "Masaje por estancia",
                  "amount": 1200.55,
                  "rateSupplementTaxesResponseList": [
                    {
                      "taxCode": "IVA",
                      "taxValue": 0.0,
                      "taxAmount": 15.968
                    }
                  ]
                },
                {
                  "supplementCode": "TOUR",
                  "supplementName": "Transportación",
                  "date": "25/03/2020",
                  "startDate": null,
                  "endDate": null,
                  "quantityType": 6,
                  "quantityValue": 1,
                  "quantityTypeText": "",
                  "unitPriceType": "F",
                  "unitPriceValue": 550.0,
                  "numSuppleCharged": 1,
                  "commOffsetType": "N",
                  "commOffsetValue": 0.0,
                  "commAmount": 0.0,
                  "mandatory": false,
                  "rateIncluded": false,
                  "supplementDescription": "Transportación",
                  "amount": 550.0,
                  "rateSupplementTaxesResponseList": [
                    {
                      "taxCode": "IVA",
                      "taxValue": 0.0,
                      "taxAmount": 15.968
                    }
                  ]
                }
              ]
              var manSuppF = response.ratesResponse.ratesDetailResponseList
              // Getting all supplement names and quantities
              var obSupp = []
              for(var i = 0; i < manSuppF.length; i++) {
                if(manSuppF[i].rateMandatorySupplementResponseList != null) {
                  for(var j = 0; j < manSuppF[i].rateMandatorySupplementResponseList.length; j++) {
                    // Get all supplemets
                    obSupp.push({ quantity: manSuppF[i].rateMandatorySupplementResponseList[j].numSuppleCharged, name: manSuppF[i].rateMandatorySupplementResponseList[j].supplementName, desc: manSuppF[i].rateMandatorySupplementResponseList[j].supplementDescription })
                  }
                }
              }

              // Find out list of non duplicates
              var obSupp2 = obSupp
              let uniqueSupp = obSupp.map(item => item.name)
                .filter((value, index, self) => self.indexOf(value) === index)
              var counter = {}
              obSupp2.forEach(function(obj) {
                var key = JSON.stringify(obj)
                counter[key] = (counter[key] || 0) + 1
              })
              // Assign number to specific key
              var descriptionMS = ""
              for(var i = 0; i < Object.keys(counter).length; i++) {
                var letJson = JSON.parse(Object.entries(counter)[i][0])
                var timesS = Object.entries(counter)[i][1]
                descriptionMS += letJson.quantity * timesS
                descriptionMS += " "
                descriptionMS += letJson.desc
                descriptionMS += ", "
              }

              // Print mandatory texts

              descriptionMS = descriptionMS.trim()
              descriptionMS = descriptionMS.slice(0, -1);
              if(descriptionMS == null || descriptionMS == "") {
                this.ls.set("descriptionMS", "")
              } else {
                this.ls.set("descriptionMS", descriptionMS)
              }
              // End of mandatory string creation

            } else {
              this.servicioName = process.env.VUE_APP_CODE;
              this.isModalErrorServicios = true;
            }
            this.initPage = false;
            // KB41067 START
            axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_GUEST + this.ls.get("Profile").data.profileType,
              {
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': 'Bearer '+ this.token,
                    'Accept-language': this.language.data,
                }
              })
              .then(res => {
                var resObject = JSON.parse(JSON.stringify(res));
                 if (resObject.status == 200 || resObject.status == 201) {
                  
                    for (var i = 0; i < resObject.data.response.length; i++) {
 
                      if(this.guestID== resObject.data.response[i].guestProfileId){
                        if(resObject.data.response[i].emailAlternative!=""){
                          this.guestEmail.push(resObject.data.response[i].emailAlternative);
                        }
                      }

                    }
                  }
                   
                })
                .catch(error => {
                });
              // End KB41067
          })
          .catch(error=>{



// Error server
            let errorObject=JSON.parse(JSON.stringify(error));
            if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
              this.$router.push({ name: "Error" });
            } else {
              this.servicioName = process.env.VUE_APP_CODE;
              this.isModalErrorServicios = true;
            }

          })
      },
      ifNull(data){
        if(data === null){
          return "";
        }
        return data;
      },
      getHabitaciones(response){
        let habitaciones = '';
        let data1 = '';
        let data2 = '';
        let roomCode = response.roomCode;
        let roomCodes = response.hotelDetailResponse.roomDetailResponseList;
        roomCodes.forEach(function(value){
          habitaciones = "";
          if(value.roomCode === roomCode){
            data1 = value.roomName;
          }else {
            data2 = i18n.t('language.posadasCorporate.reservacionCancelacion.noEncontrado');
          }
        });

        if(data1 !== ''){
          habitaciones = data1;
        }else{
          habitaciones = data2;
        }

        return habitaciones;
      },

      getRoomImagen(response){
        let roomImagen = '';
        let roomCode = response.roomCode;
        let roomCodes = response.hotelDetailResponse.roomDetailResponseList;
        roomCodes.forEach(function(value){
          if(value.roomCode === roomCode){
            roomImagen =   value.roomName;
          }else {
            roomImagen = "";
          }
        });
        return roomImagen;
      },
      getHuesped(response){
        let huespedes = response.totalAdults + response.totalChildren + response.totalInfants;
        let huesped =  "";
        if(huespedes > 1){
          huesped = " " + huespedes + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.huespedes');
        }else if(huespedes === 1){
          huesped = " " + huespedes + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.huesped');
        }
        return huesped;
      },
      getTotalAdults(totalAdults){
        let totalAdult = "";
        if(totalAdults > 1){
          totalAdult = " " + totalAdults + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.adultos');
        }else if(totalAdults === 1){
          totalAdult = " " + totalAdults + "  " +i18n.t('language.posadasCorporate.reservacionCancelacion.adulto');
        }
        return totalAdult;
      },
      getTotalChildren(totalChildrens){
        let totalChildren = "";
        if(totalChildrens > 1){
          totalChildren = ", " + totalChildrens + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.menores');
        }else if(totalChildrens === 1){
          totalChildren = ", " + totalChildrens + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.menor');
        }
        return totalChildren;
      },
      getTotalInfants(totalInfants){
        let totalInfant = "";
        if(totalInfants > 1){
          totalInfant = " y " + totalInfants + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.infantes');
        }else if(totalInfants === 1) {
          totalInfant = " y " + totalInfants + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.infante');
        }
        return totalInfant;
      },
      getTotalRooms(totalRooms){
        let totalRoom = 0;
        if(totalRooms > 1){
          totalRoom = " " + totalRooms + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.habitaciones');
        }else if(totalRooms === 1) {
          totalRoom = " " + totalRooms + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.habitacion');
        }
        return totalRoom;
      },
      getTextNights(numNights){
        let numberNights = 0;
        if(numNights > 1){
          numberNights = " " + numNights + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.noches');
        }else if(numNights === 1) {
          numberNights = " " + numNights + " "+i18n.t('language.posadasCorporate.reservacionCancelacion.noche');
        }
        return numberNights;
      },
      currency(amount) {
        return Number(amount).toLocaleString(undefined, {maximumFractionDigits: 2}) || '0';
      },
      getPaymentType(paymentResponse){
        let value = '';
        if(paymentResponse.voucher != null){
          value = paymentResponse.voucher.voucherNumber;
        }
        if(paymentResponse.creditCard != null){
          this.tarjeta = true;
          value = paymentResponse.paymentMethod;
          this.cardHolderName= paymentResponse.creditCard.cardHolderName;
          this.cardNumber= paymentResponse.creditCard.cardNumber;
          this.cardType= paymentResponse.creditCard.cardType;
          this.expirationDate= paymentResponse.creditCard.expirationDate;
        }
        return value
      },
      cancelReservation(){
        let ls = new SecureLS({encodingType: 'aes'});
        this.language = this.ls.get('Language'); // set key1
        var a = '';
        a = this.ls.get('Token'); // localStorage.getItem('Token');
        this.token = a.data.substr(1);

        // Servicio que realiza la cancelación de una reservación de hotel
        axios.delete(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_CANCELRES, {
          headers: {
            'Authorization': 'Bearer '+ this.token,
            'Accept-language': this.language.data,
          },
          data : {
            "reservationNumber": this.noReservacion,
            "cancelType": this.code,
            "comments": this.comentario.trim(),
            "poscode": "WS02"
          }
        }).then(res => {
          let resObject=JSON.parse(JSON.stringify(res));
          if(resObject.data.response.cancelId!= null){
            this.cancelationNumber = resObject.data.response.cancelId;
            this.ls.set('nomeroCancelacion', resObject.data.response.cancelId);
            this.setDataEmail();
          }
        })
          .catch(error => {
            let errorObject=JSON.parse(JSON.stringify(error));
            if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
              this.$router.push({ name: "Error" });
            } else {
              this.enableLoader = false;
              this.servicioName = process.env.VUE_APP_CANCELRES;
              this.isModalErrorServicios = true;
            }
          })
      },
      getPoliticasTarifas(){
        this.enableLoader = true;
        let ls = new SecureLS({encodingType: 'aes'});
        this.language = this.ls.get('Language');
        var a = '';
        a = this.ls.get('Token');
        this.token = a.data.substr(1);
        const profile = this.ls.get('Profile').data;
        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_RP, {
          hotelCode:this.hotelCode,
          arrivalDate: this.checkIn, //this.getDate(this.checkIn),
          departureDate: this.checkOut, //this.getDate(this.checkOut),
          contractCode:this.contractCode,
          contractType: this.contractTypeCode,
          currencyCode:this.currencyCode,
          showRates: ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:profile.ratesPermissionsResponse.showRates),
          showPublicRates: ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:profile.ratesPermissionsResponse.showPublicRates),
          hasCombinedRate: false,
          dailyRate:this.dailyRate,
          totalRate:Number(this.totalCostWithTaxes)
        }, {
          withCredentials: true,
          credentials: 'include',
          headers: {'Authorization': 'Bearer '+ this.token,
            'Accept-Language': this.language.data,
            'Content-Type' : 'application/json'
          }
        })
          .then(res => {
            this.ratePolicy = [];
            let resObject = JSON.parse(JSON.stringify(res));
            let response = resObject.data.response;
            if ( resObject.status === 200 || resObject.status === 201) {
              this.ratePolicy = resObject.data.response;
              this.ls.set('HotelDetailDataPoliticas', {data: resObject.data});
              this.cancelReservation()
            }
          })
          .catch(error=>{
            // Error server
            if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
              this.$router.push({ name: "Error" });
            }
// Error server
            this.servicioName = process.env.VUE_APP_RP;
            this.isModalErrorServicios = true;
          })
      },

// buscador
      cambiaValue(perfil) {
        this.code = perfil.cancelType;
        return this.search = perfil.nombre;
      },

// Cerrar inputs
      outsideSearch(e) {
        this.buscador = false;
      },
      getDate(fecha){
        let date = '';
        let ls = new SecureLS({encodingType: 'aes'});
        this.language = this.ls.get('Language');
        if(this.language.data === 'en'){
          date = fecha.split("/");
          date = date[1]+"/"+date[0]+"/"+date[2];
        }else {
          date = fecha;
        }
        return date;
      },
      setDataEmail(){
        let ls = new SecureLS({encodingType: 'aes'});

        this.language = this.ls.get('Language'); // set key1
        var a = '';
        a = this.ls.get('Token');
        let profile = this.ls.get("Profile").data;
        let hotelDetail = this.ls.get("HotelDetailData").data;
        let politicas = this.ls.get("HotelDetailDataPoliticas");
        var ban = false;
        if (hotelDetail.hotelDetailResponse.specialMessage.length > 0) {
          ban = true;
        }

        let benefist = '';
        let restrictions = '';
        if(hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList.length >= 1){
          benefist = hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList[0].benefits;
          restrictions = hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList[0].restrictions;
        }

        this.guestEmail.push(profile.email);
        this.guestEmail.push("reservacionescorporate@posadas.com");
        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI+process.env.VUE_APP_CM, {
          email                  : this.guestEmail,
          reservationNumber      : this.noReservacion,
          cancelationNumber      : this.cancelationNumber,
          reservationStatusCode  : "01",
          hotelCode              : this.hotelCode,
          hotelName              : this.hotelName,
          benefits               : benefist,
          restrictions : restrictions,
          servicesTable : "servicesTable",
          rateTypeCode : hotelDetail.roomContractTypeCode,
          contractCode : hotelDetail.roomContractCode,
          numRooms : hotelDetail.totalRooms,
          amenityList : hotelDetail.hotelDetailResponse.amenityList,
          ratesResponse : hotelDetail.ratesResponse,
          showRates : ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:profile.ratesPermissionsResponse.showRates),
          showPublicRates : ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:profile.ratesPermissionsResponse.showPublicRates),
          supplementDescription : this.ifNull(hotelDetail.supplementResponse),
          roomName : this.getHabitaciones(hotelDetail),
          roomCode : hotelDetail.roomCode,
          mainGuestName : hotelDetail.name,
          mainMiddleName : "",
          mainGuestLastName : hotelDetail.fatherSurname,
          mainGuestMotherMaidenName : hotelDetail.motherSurname,
          companionGuestName              : hotelDetail.companionName,
          companionGuestLastName          : hotelDetail.companionFatherSurname,
          companionGuestMotherMaidenName  : hotelDetail.companionMotherSurname,
          todayDate     : new Date().toISOString().slice(0, 10),
          arrivalDate   : hotelDetail.arrivalDate,
          departureDate : hotelDetail.departureDate,
          currencyCode  : hotelDetail.currencyCode,
          totalAdults   : hotelDetail.totalAdults,
          totalChildren : hotelDetail.totalChildren,
          totalInfants  : hotelDetail.totalInfants,
          hotelAddress  : hotelDetail.hotelDetailResponse.hotelAddress,
          promotion     : hotelDetail.roomContractTextName,
          supplements : "supplements",
          specialRequirements : hotelDetail.requirementTypeResponse,
          penalty : "",
          groupName           : "",
          groupType           : "",
          policyDescription   : hotelDetail.travelPolicy,
          brand               : hotelDetail.brandName,
          brandImage          : hotelDetail.hotelDetailResponse.brandImage,
          guestTitle          : "",
          dueDate             : new Date().toISOString().slice(0, 10),
          paymentType         : hotelDetail.paymentResponse.paymentMethod,
          voucherResponse     : hotelDetail.paymentResponse.voucher,
          creditCardResponse  : hotelDetail.paymentResponse.creditCard,
          apreciareNumber : hotelDetail.apreciareClubNumber,
          fiestaRewardsNumber : hotelDetail.fiestaRewardsNumber,
          motivaNumber : hotelDetail.motivaNumber,
          employeeNumber : hotelDetail.employeeNumber,
          nights : hotelDetail.numberOfNights,
          coupon : this.ifNull(hotelDetail.couponNumber),
          phone : hotelDetail.hotelDetailResponse.hotelPhone,
          rateType : hotelDetail.roomContractTypeName,
          guarantee : "guarantee",
          guaranteeType: "guaranteeType",
          dailyCost         : hotelDetail.ratesResponse.totalCostWithoutTaxes,
          totalPerNight     : hotelDetail.ratesResponse.ratesDetailResponseList[0].roomCostWithTaxes,
          totalSupplements  : hotelDetail.ratesResponse.totalSupplements,
          totalTaxes        : hotelDetail.ratesResponse.totalTaxes,
          totalCost         : hotelDetail.ratesResponse.totalCostWithTaxes,
          hotelImage : hotelDetail.hotelDetailResponse.hotelMailImage,
          roomImage :  this.getRoomImagen(hotelDetail),
          mapImage : "",
          reasonTrip : "2",
          discountCode : hotelDetail.discountCode,
          socialReasonResponse : hotelDetail.socialReasonResponse,
          ratePolicyElementResponseList : this.ratePolicy.ratePolicyElementResponseList,
          sendSpecialConsiderations: ban,
          rateOptionalSupplementList: this.rateOptionalSupplementResponseList
        }, {
          withCredentials: true,
          credentials: 'include',
          headers: {'Authorization': 'Bearer '+ this.token,
            'Accept-Language': this.language.data,
            'Content-Type' : 'application/json'
          }
        })
          .then(res => {
            let resObject = JSON.parse(JSON.stringify(res));
            let response = resObject.data.response;
            if ( resObject.status === 200 || resObject.status === 201) {
              this.ratePolicy = resObject.data.response;
            }
            this.$router.push({ name: "ReservacionesCancelada" });
          })
          .catch(error=>{
            // Error server
            let errorObject=JSON.parse(JSON.stringify(error));
            if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
              this.$router.push({ name: "Error" });
            }
            this.servicioName = process.env.VUE_APP_CM;
            this.isModalErrorServicios = true;

          });
      },
    },
    watch: {
      comentario(){
        var rtrim = /^[\s\uFEFF\xA0]+$/g;
        this.comentario = this.comentario.replace(rtrim, '');
      }
    },
    computed: {
// buscador
      filteredList() {
        return this.perfiles.filter(perfil => {
          return perfil.nombre.toLowerCase().includes(this.search.toLowerCase())
        })
      },
      isDisabled() {
        if (this.search.length > 0 && this.comentario.length > 0) {
          return false;
        } else {
          return true;
        }
      },
    },
    filters: {
      resalt: function (value,valueFromSearch) {
        if (!value) return ''
        valueFromSearch != '' ? value = value.replace(valueFromSearch, '<span class="PC-text--semibold PC-color--colorBase2">'+valueFromSearch+'</span>') : value = value;
        return value;
      }
    },
    directives: {
      'click-outside': {
        bind: function(el, binding, vNode) {
          // Provided expression must evaluate to a function.
          if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}'` }
          }
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler
          // add Event Listeners
          document.addEventListener('click', handler)
        },
        unbind: function(el, binding) {
          // Remove Event Listeners
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/config.scss';

  .buscadorCard__custom-width {
    width: 97.2%;
    @media (max-width:1024px) {
      width: 96% !important;
      border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }
    @media (max-width:658px) {
      width: 95% !important;
    }
    @media (max-width:425px) {
      width: 93% !important;
    }
  }

  .imgCancelacion {
    width: 100px;
    height: 55px;

  }

  .infoParrafo {
    font-size: 14px !important;
  }

  .contentContacto {
    display: flex;
    position: relative;
    min-height: 70vh;
  }

  .contacto {
    width: 100%;
    margin-top: 57px;
    padding-top: 32px;

    .card-body {
      min-height: 181px;

      .card-title {
        font-size: $font-size-large;
      }
    }

    .estancia {
      font-size: $font-size-biglarge;
      font-weight: bold;
    }
  }

  .cancelarReserva {
    .card-header {
      background-color: #d1ecf1;
    }

    .referencia {
      color: $colorBase2;
    }
  }

  .enlacesContacto {
    color: $colorBase2;
    font-weight: 500;

    .demo-icon {
      font-size: $font-size-biglarge;
    }
  }

  textarea {
    height: 100px;
  }
  @media only screen and (max-width: 992px) {
    .imgCancelacion {
      width: 100%;
      height: auto;
    }
  }
</style>
